export function getHeader(url, code) {
  let timestamp = new Date() * 1;
  let token =
    sessionStorage.getItem("token") === null
      ? ""
      : sessionStorage.getItem("token");
  let source = "web";
  let sign = source + url + code + timestamp + token;
  return {
    "Content-Type": "application/json;charset=UTF-8",
    'X-Access-Token': token,
    timestamp: timestamp,
    code: code,
    sign: sign,
    source: source,
  };
}
